import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=4fbf3a47&scoped=true&"
import script from "./staff.vue?vue&type=script&lang=js&"
export * from "./staff.vue?vue&type=script&lang=js&"
import style0 from "./staff.vue?vue&type=style&index=0&id=4fbf3a47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf3a47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbf3a47')) {
      api.createRecord('4fbf3a47', component.options)
    } else {
      api.reload('4fbf3a47', component.options)
    }
    module.hot.accept("./staff.vue?vue&type=template&id=4fbf3a47&scoped=true&", function () {
      api.rerender('4fbf3a47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaves/staff.vue"
export default component.exports